import { Primitive } from '../../../types/blocks/Primitive';

const FileBlock: Primitive = {
  name: 'FileBlock',
  friendlyName: 'File',
  isInput: false,
  isPrimitive: true,
  properties: {
    file: {
      type: 'Media',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default FileBlock;
